import { render } from "./CajaApertura.vue?vue&type=template&id=cca748c8&scoped=true"
import script from "./CajaApertura.vue?vue&type=script&lang=js"
export * from "./CajaApertura.vue?vue&type=script&lang=js"

import "./CajaApertura.vue?vue&type=style&index=0&id=cca748c8&scoped=true&lang=scss"

import exportComponent from "C:\\laragon\\www\\clogistica_front\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cca748c8"]])

export default __exports__